import { flow, getParent, getRoot, types } from 'mobx-state-tree';
import { when } from 'mobx';
import ENUMS from '../../constants/enums';
import { fireAllConfetti } from '../../utils/confetti';

const URL = 'account/v1/Accounts';
// const hsOnboardingAdvance = '000010424472';

const OnboardingStore = types
  .model('onboardingStore', {
    flow: types.optional(
      types.union(types.literal('test'), types.literal('tutorial'), types.literal('done')),
      'test',
    ),
    wizardStepIndex: types.optional(types.number, 0),
    tutorialStepIndex: types.optional(types.number, 0),
    runWizard: types.optional(types.boolean, true),
    runTutorial: types.optional(types.boolean, true),
    nextWizardStepValid: types.optional(types.boolean, true),
    nextValidTutorialStep: types.optional(types.number, 0),
    wizardDone: types.optional(types.boolean, true),
    tutorialEnabled: types.optional(types.boolean, false),
    storeInitialized: types.optional(types.boolean, false),
    storeLoading: types.optional(types.boolean, true),
    numberOfLogins: types.optional(types.number, 1),
    tutorialTransitioning: types.optional(types.boolean, false),
    triggerMaximize: types.optional(types.boolean, false),
    importSource: types.optional(types.number, 1),
    importedData: types.optional(types.array(types.frozen), []),
    destinationAccountId: types.optional(types.string, ''),
    isPaypalCardOption: types.optional(types.boolean, false),
    openCourseFromOnboarding:false,
    promotionModalOpen:false,
  })
  .views(self => ({
    get discoveryStore() {
      return getRoot(self).uiStore.discoveryStore;
    },
    get settingsStore() {
      return getRoot(self).uiStore.settingsStore;
    },
    get transport5007() {
      return getParent(self).transport5007;
    },
    get accountCode() {
      return getParent(self).sessionStore.accountCode;
    },
    get userProfile() {
      return self.settingsStore.userProfile;
    },
    get browserHistory() {
      return getParent(self).routingStore.browserHistory;
    },
    get noImportedData() {
      return !self.importedData.length;
    },
    get incompleteData() {
      return self.importedData.length === 1 && Object.keys(self.importedData[0]).length < 2;
    },
    get sellerAccounts() {
      return self.settingsStore.markets.sellersAccounts;
    },
    get defaultSellersAccount() {
      return self.settingsStore.markets.defaultSellersAccount;
    },
    get defaultQuantityToList() {
      return self.settingsStore.listing.listingOptions.defaultQuantityToList || 1;
    },
    get currentPlan() {
      return self.settingsStore.subscription.currentPlan;
    },
    get lastConnectedPaypalName() {
      return getParent(self).settingsStore.connectionManagement.lastConnectedPaypalName;
    },
  }))
  .actions(self => ({
    initStore() {
      try {
        self.storeLoading = true;
        const { wizardExperienceLevel, wizardStatus } = self.userProfile;
        // const wizardStatus = 'STEP_O_O';
        // const wizardExperienceLevel = '';

        const savedFlow = wizardExperienceLevel.toLowerCase();
        // self.setFlow(savedFlow);
        const onboardingLevel=wizardStatus.split('_');
        // TO DO: Refactor this or change it if you increase the number of steps in onboarding
        if(onboardingLevel.length > 1){
          if (Number(onboardingLevel[1]) >= 2) {
            return;
          }
        }

        // if (savedFlow === 'done') {
        //   return;
        // }

        const savedNumberOfLogins = parseInt(wizardStatus.slice(7), 10);
        self.setNumberOfLogins(savedNumberOfLogins);
        if (savedNumberOfLogins >= 3) {
          return;
        }
        self.increaseNumberOfLogins();

        if (savedFlow === 'tutorial') {
          self.finishWizard();
          self.browserHistory.replace('/');
          self.tutorialEnabled = true;
          return;
        }

        const savedWizardStep = parseInt(wizardStatus.slice(5, 6), 10) + 1;
        self.setWizardStep(savedWizardStep);
        if (savedWizardStep === 5) {
          self.finishWizard();
        } else {
          self.wizardDone = false;
          if (!self.storeInitialized && self.currentPlan) {
            self.runWizard = true;
          }
        }
        when(
          () => self.defaultSellersAccount && self.defaultSellersAccount.id,
          () => self.setDestinationAccountId(self.defaultSellersAccount.id),
        );
      } catch (error) {
        console.error('getting UserProfile failed: ', error);
      } finally {
        self.storeLoading = false;
        self.storeInitialized = true;
      }
    },
    setUserType(val) {
      self.userProfile.setType(val);
    },
    setOpenCourseFromOnboarding(val){
      self.openCourseFromOnboarding=val;
    },
    setPromotionModalOpen(val){
      self.promotionModalOpen=val;
    },
    setIsPaypalCardOption(val){
      self.isPaypalCardOption=val;
    },
    updateOnboardingLevel(value) {
      self.userProfile.updateOnboardingLevel(value);
    },
    toggleTriggerMaximize() {
      self.triggerMaximize = !self.triggerMaximize;
    },
    setNumberOfLogins(num) {
      if ((num || num === 0) && typeof num === 'number') {
        self.numberOfLogins = num;
      }
    },
    increaseNumberOfLogins() {
      // this functionality doesn't make sense anymore, since we should not allow free users to
      // close the onboarding in any way shape or form. (check TRIP-505 + comments)
      // if (localStorage.getItem('loginCounted')) {
      //   return;
      // }
      // self.numberOfLogins++;
      // self.saveStep();
      // localStorage.setItem('loginCounted', 'true');
    },
    finishWizard() {
      self.wizardDone = true;
      self.userProfile.identifyHubspot({
        phone: self.userProfile.phoneNumber,
        country: self.userProfile.country,
        lastName: self.userProfile.lastName,
        firstName: self.userProfile.firstName,
      });
    },
    toggleWizard() {
      if (!self.runWizard && !self.storeInitialized) {
        self.initStore();
        return;
      }
      self.runWizard = !self.runWizard;
    },
    setWizardStep(stepNumber) {
      if ((stepNumber || stepNumber === 0) && typeof stepNumber === 'number') {
        self.wizardStepIndex = stepNumber;
      }
    },
    setTutorialStep(stepNumber) {
      if ((stepNumber || stepNumber === 0) && typeof stepNumber === 'number') {
        self.tutorialStepIndex = stepNumber;
      }
    },
    setFlow(flowType) {
      if (['beginner', 'test', 'tutorial', 'done'].includes(flowType)) {
        self.flow = flowType;
      }
    },
    setCountry(country) {
      if (typeof country === 'string') {
        self.userProfile.setCountry(country);
      }
    },
    setPhoneNumber(phoneNumber) {
      if (typeof phoneNumber === 'string') {
        self.userProfile.setPhoneNumber(phoneNumber);
      }
    },
    setPhoneNumberCountryCode(countryCode) {
      if (typeof countryCode === 'string') {
        self.userProfile.setPhoneNumberCountryCode(countryCode);
      }
    },
    setFirstName(name) {
      if (typeof name === 'string') {
        self.userProfile.setFirstName(name);
      }
    },
    setLastName(name) {
      if (typeof name === 'string') {
        self.userProfile.setLastName(name);
      }
    },
    setIsNonApi(isNonApi) {
      self.settingsStore.subscription.setPlansEmpty();
      self.userProfile.setIsNonApi(isNonApi);
      self.userProfile.updateProfile();
      self.settingsStore.subscription.fetchPlans();
    },
    saveWizardState: flow(function* saveWizardState() {
      try {
        const payload = [
          {
            op: 'replace',
            path: '/wizardStatus',
            value: `STEP_${self.wizardStepIndex}_${self.numberOfLogins}`,
          },
          // {
          //   op: 'replace',
          //   path: '/wizardExperienceLevel',
          //   value: self.flow.toUpperCase(),
          // },
        ];
        switch (self.wizardStepIndex) {
          case 2: {
            self.userProfile.identifyHubspot({
              phone: self.userProfile.phoneNumber,
              country: self.userProfile.country,
              lastName: self.userProfile.lastName,
              firstName: self.userProfile.firstName,
            });
            break;
          }
          case 4: {
            self.userProfile.identifyHubspot({
              paypalEmail: self.lastConnectedPaypalName,
            });
            break;
          }
          default: {
            console.log(self.wizardStepIndex);
            break;
          }
        }
        const headers = {};
        yield self.transport5007.patch(`${URL}/${self.accountCode}`, payload, {}, headers);
      } catch (e) {
        console.error(e);
      }
    }),
    saveStep: flow(function* saveStep() {
      try {
        const payload = [
          {
            op: 'replace',
            path: '/wizardStatus',
            value: `STEP_${self.wizardStepIndex}_${self.numberOfLogins}`,
          },
        ];
        const headers = {};
        yield self.transport5007.patch(`${URL}/${self.accountCode}`, payload, {}, headers);
      } catch (e) {
        console.error(e);
      }
    }),
    saveFlow: flow(function* saveFlow() {
      try {
        const payload = [
          {
            op: 'replace',
            path: '/wizardExperienceLevel',
            value: self.flow.toUpperCase(),
          },
        ];
        const headers = {};
        yield self.transport5007.patch(`${URL}/${self.accountCode}`, payload, {}, headers);
      } catch (e) {
        console.error(e);
      }
    }),
    disableNextWizard() {
      self.nextWizardStepValid = false;
    },
    enableNextWizard() {
      self.nextWizardStepValid = true;
    },
    enableNextTutorial(step) {
      if (self.flow === 'tutorial' && self.runTutorial && self.nextValidTutorialStep === step - 1) {
        self.nextValidTutorialStep = step;
      }
    },
    minimizeTutorial() {
      self.setTutorialStep(0);
      self.nextValidTutorialStep = 0;
      self.runTutorial = false;
    },
    maximizeTutorial() {
      self.browserHistory.replace('/');
      self.runTutorial = true;
    },
    congratulate() {
      fireAllConfetti();
      const text = document.createElement('DIV');
      text.innerText = 'Congratulations!';
      text.id = 'tm-congratulations';
      document.body.appendChild(text);
      setTimeout(() => {
        text.remove();
      }, 3500);
    },
    enableTutorial() {
      if (!self.wizardDone) {
        self.finishWizard();
      }
      self.congratulate();
      self.browserHistory.replace('/');
      self.tutorialEnabled = true;
      self.setFlow('tutorial');
      self.saveFlow();
    },
    finish() {
      if (!self.wizardDone) {
        self.finishWizard();
      }
      self.congratulate();
      self.browserHistory.replace('/');
      self.disableTutorial();
    },
    disableTutorial() {
      self.tutorialEnabled = false;
      self.setFlow('done');
      self.saveFlow();
    },
    updateUserProfile() {
      self.userProfile.updateProfile();
    },
    updateBasicInfo() {
      self.userProfile.updateProfile();
      self.updateOnboardingLevel('personal details');
    },
    startTransition() {
      self.tutorialTransitioning = true;
    },
    endTransition() {
      self.tutorialTransitioning = false;
    },
    importCSV: flow(function* importCSV() {
      self.discoveryStore.setDiscoverMarket(self.importSource);
      // const resp = yield self.discoveryStore.getSellersAccounts();
      // if(resp) {
      // }
      self.discoveryStore.setSellerAccount(
        self.destinationAccountId ? { id: self.destinationAccountId } : self.defaultSellersAccount,
      );
      const response = yield self.discoveryStore.getStrategyDefaults();
      if (response) {
        yield self.discoveryStore.getPoliciesForSellerAccount();
        self.discoveryStore.setStrategy(Number(Object.keys(response.toJSON())[0]));
      }
      const defaultPolicy = self.discoveryStore.getDefaultPolicyCode();
      if (!defaultPolicy) {
        return {
          errorMessage: 'No Business Policy Data',
        };
      }
      const reqData = {
        accountCode: self.accountCode,
        sellerAccountCode: self.destinationAccountId || self.defaultSellersAccount.id,
        sourceId: self.importSource,
        destinationId: self.discoveryStore.listingMarket,
        discoveryBody: self.importedData.map(({ source_id, destination_id }) => ({
          id: source_id,
          destinationItemId: destination_id,
        })),
        discoveryStrategy: self.discoveryStore.rangedProfitSelected
          ? self.discoveryStore.strategies.toJSON()[ENUMS.STRATEGY.FIXED_PROFIT].properties
          : self.discoveryStore.strategies.toJSON()[self.discoveryStore.discoverStrategy]
              .properties,
        usePredefined: self.discoveryStore.rangedProfitSelected,
        discoveryMethod: 2,
        policyCode: defaultPolicy ? defaultPolicy.code : '',
        isWithVariations: false,
        defaultQuantity: self.defaultQuantityToList,
      };
      console.log(reqData);
      try {
        if (reqData.discoveryBody.length >= 5000) {
          const respError = {
            response: {
              data: {
                errorMessage: `Please use less than 5000 items in one import. You used ${
                  reqData.discoveryBody.length
                }.`,
              },
            },
          };
          throw Object.assign(new Error('Too many ids'), respError);
        }
        const { data } = yield self.transport5007.post(
          'discovery-new/v1/pre-discovery/import-listings',
          reqData,
          null,
          {},
        );
        if (!self.runWizard) {
          self.disableTutorial();
          self.finishWizard();
        }
        console.log(data);
        return data;
      } catch (error) {
        const { data } = error.response;
        return (
          data || {
            errorMessage: 'There was an error importing the listing/s',
          }
        );
      }
    }),
    setImportSource: value => {
      self.importSource = value;
    },
    setDestinationAccountId: value => {
      self.destinationAccountId = value;
    },
    setImportedData: value => {
      if (Array.isArray(value)) {
        self.importedData = value;
      }
    },
  }));

export default OnboardingStore;
